import { Button, Form } from 'antd';
import { CreateUserDTO,UpdateUserDTO  } from 'features/users/api/user-api.service';
import { UserInfoFormItems } from 'features/users/components/modals/user-info-form-items';
import {UserFormField,UserFormValues} from 'features/users/components/users-filter-form';    
import { useCreateUser, useUpdateUser } from 'features/users/use-cases';
import { useEffect, useState } from 'react';

import { PasswordFormItems } from './password-form-items';

export const AddAppUserModal = ({ onClose, userEditData }: { onClose: () => void, userEditData: any }) => {
    const formName = 'add-user-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UserFormValues>();
    const { isLoading, mutate } = useCreateUser();
    const handleClose = () => {
        onClose();
        form.resetFields();
    }

    useEffect(() => {
          
        if (userEditData) {
            userEditData.role = parseInt(userEditData.role) ;
            form.setFieldsValue(userEditData);           
        } else {
            form.resetFields();
        }

    }, [userEditData, form]);

     

    const getInitialValues = {
        [UserFormField.FirstName]: undefined,     
        [UserFormField.PhoneNumber]: undefined,    
        [UserFormField.Role]: undefined,
        [UserFormField.Email]: undefined,
      
    };

    const { mutate: mutateUpdateUser } = useUpdateUser();
       

    const handleUserUpdate = (formData: any) => {

        const payload: UpdateUserDTO = {
            userId: formData.UserId, 
            name: formData.name,   
            password: formData.password,
            phoneNumber: formData.phoneNumber,  
            email: formData.email.length ? formData.email : null,          
            isActive: formData.isActive,
            roleType: formData.role            
        };       

        mutateUpdateUser(payload, { onSuccess });
    };

    const handleUpdate = (formData: UserFormValues) => {  

        if (userEditData) {
            formData.UserId = userEditData.userId;
            handleUserUpdate(formData);
        } else {
              
            const fomrD:CreateUserDTO = {
                name:formData.name ,
                email:formData.email ,
                phoneNumber:formData.phoneNumber,
                roleType:formData.role,
                isActive:formData.isActive,
                password:formData.password  
            }
         
            mutate(fomrD, { onSuccess: handleClose });
        }
    };

    const onSuccess = () => {
        handleClose();
    };

    return (
        <>
            <div className={'popup'}>
                <div className='modal_head'>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                    <h4>{userEditData ? 'Edit User' : 'Add User'}</h4>
                </div>
                <div className='modal_body'>
                    <Form<UserFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        
                        onFinish={handleUpdate}                      
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                         
                        
                    >
                        <UserInfoFormItems />
                        {!userEditData ? (<PasswordFormItems />) : ''}

                        <div className='form-button'>
                            <Button type="primary" htmlType='submit' className="btn" >Save</Button>
                        </div>
                    </Form>
                </div>
            </div>

        </>
    );
};

